import React from 'react';
import MaterialTable from 'material-table';
import PropTypes from 'prop-types';

const propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
};

const defaultProps = {
  data: [],
  columns: [],
};
function ProLinkTable({
  data,
  columns,
}) {
  return (
    <MaterialTable
      title={null}
      columns={columns}
      options={{
        search: false,
        pageSize: 10
      }}
      data={data}
    />
  );
}

ProLinkTable.propTypes = propTypes;
ProLinkTable.defaultProps = defaultProps;
export default ProLinkTable;



// WEBPACK FOOTER //
// ./src/components/ProLinckTable/index.jsx